import React from 'react';
import { snakeCaseToTitleCase } from '~/lib/cases';
import { isDecPageField } from '~/utils/dec_page_fields';
const cellValue = (value) => {
    if (!value)
        return '';
    if (typeof value === 'string')
        return value;
    if (typeof value === 'number')
        return JSON.stringify(value);
    if (value instanceof Array) {
        return value.join(', ');
    }
    return JSON.stringify(value);
};
const valueFormatted = (indent, value) => {
    if (!value)
        return React.createElement(React.Fragment, null);
    if (typeof value === 'string' || typeof value === 'number')
        return React.createElement(React.Fragment, null, value);
    if (value instanceof Array) {
        return React.createElement(React.Fragment, null,
            '\xA0'.repeat(indent),
            value.map(item => React.createElement(React.Fragment, null,
                valueFormatted(indent, item),
                React.createElement("br", null))));
    }
    if (typeof value === 'object' && !Array.isArray(value)) {
        return React.createElement(React.Fragment, null, Object.keys(value).map(key => {
            var _a;
            let newValue = value[key];
            if (isDecPageField(newValue))
                newValue = (_a = newValue.value) !== null && _a !== void 0 ? _a : '';
            const title = snakeCaseToTitleCase(key);
            const valueIsObject = typeof newValue === 'object' && !Array.isArray(newValue);
            return React.createElement(React.Fragment, null,
                '\xA0'.repeat(indent),
                React.createElement("b", null, title),
                ":",
                valueIsObject ? React.createElement("br", null) : '\xA0',
                valueFormatted(indent + 4, newValue),
                React.createElement("br", null));
        }));
    }
    return React.createElement("pre", null, JSON.stringify(value, null, 2));
};
const cellValueFormatted = (decPageData) => {
    return React.createElement(React.Fragment, null,
        decPageData.subkey && React.createElement(React.Fragment, null,
            React.createElement("b", null, decPageData.subkey),
            React.createElement("br", null)),
        valueFormatted(0, decPageData.value));
};
const modalValueFormatted = (decPageData) => {
    return React.createElement(React.Fragment, null,
        decPageData.subkey && React.createElement(React.Fragment, null,
            React.createElement("b", null, decPageData.subkey),
            React.createElement("br", null)),
        React.createElement("b", null, "Value"),
        ":",
        React.createElement("br", null),
        valueFormatted(0, decPageData.value),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("b", null, "Confidence"),
        ":\u00A0",
        decPageData.confidenceScore);
};
export default { cellValue, cellValueFormatted, modalValueFormatted };
